'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.threadHistoryToMessageList = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert a ThreadHistory to List<PubNubMessageRecords> 
 * 
 * @param {ThreadHistory} threadHistory 
 * @returns {List}
 */
var threadHistoryToMessageList = exports.threadHistoryToMessageList = function threadHistoryToMessageList(threadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  return (0, _pipe2.default)(_getters.getMessages, function (messages) {
    return messages && messages.toList();
  })(threadHistory);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/threadHistoryToMessageList.js
// module id = 1084
// module chunks = 2 3